// Apps that can load into the left-panel app slot. The menu, store and panel
// switch are registry-driven, so a new app needs only this file + its panel.
export const APPS = [{ id: "framex", label: "FrameX" }];

/** Re-picking the active app closes it (returns null); otherwise switches. */
export function toggleApp(current, id) {
  return current === id ? null : id;
}
